export const SHIFT_NOTIFICATION_TYPES = {
    CREATED: 'shift_created',
    EMPLOYEE_REGISTERED: 'shift_employee_registered',
    OPENED: 'shift_opened',
    CLOSING: 'shift_closing',
    CLOSED: 'shift_closed',
    CLOSE_FAILED: 'shift_close_failed',
    ERROR: 'shift_error',
}
